<template>
  <div v-if="loading" class="my-5 text-center"><i class="fa fa-spinner fa-spin"></i></div>
  <div v-else class="page company">
    <!-- COMPANY NAME -->
    <div class="form-group row">
      <label for="name" class="col-12 col-md-3 col-form-label" style="font-size: small;">{{ printLang('MyAccount.Company.Name') }}&nbsp;:&nbsp;</label>
      <div class="col-md-6 col-lg-4">
        <input id="name" v-model="company.name" type="text" class="form-control" @input="displaySaveButton('name')">
      </div>
      <div>
        <button v-if="showSave.name" class="btn btn-success" @click="updateCompanyData('name')">
          {{ printLang('MyAccount.Profile.Change') }}
        </button>
      </div>
      <p v-if="success.name" class="text-success d-flex align-items-center m-0">Modifié</p>
      <div v-if="error.name" class="col-12 text-danger">{{ error.name }}</div>
    </div>
    <!-- COMPANY EMAIL -->
    <div class="form-group row">
      <label for="email" class="col-12 col-md-3 col-form-label" style="font-size: small;">{{ printLang('MyAccount.Company.Email') }}&nbsp;:&nbsp;</label>
      <div class="col-md-6 col-lg-4">
        <input id="email" v-model="company.email" type="text" class="form-control" @input="displaySaveButton('email')">
      </div>
      <div>
        <button v-if="showSave.email" class="btn btn-success" @click="updateCompanyData('email')">
          {{ printLang('MyAccount.Profile.Change') }}
        </button>
      </div>
      <p v-if="success.email" class="text-success d-flex align-items-center m-0">Modifié</p>
      <div v-if="error.email" class="col-12 text-danger">{{ error.email }}</div>
    </div>
    <!-- COMPANY POSTAL ADDRESS -->
    <div class="form-group row">
      <label for="postal_address" class="col-12 col-md-3 col-form-label" style="font-size: small;">{{ printLang('MyAccount.Company.PostalAddress') }}&nbsp;:&nbsp;</label>
      <div class="col-md-6 col-lg-4">
        <textarea id="postal_address" v-model="company.postal_address" class="form-control" rows="2" @input="displaySaveButton('postal_address')">
        </textarea>
      </div>
      <div>
        <div>
          <button v-if="showSave.postal_address" class="btn btn-success" @click="updateCompanyData('postal_address')">
            {{ printLang('MyAccount.Profile.Change') }}
          </button>
        </div>
        <p v-if="success.postal_address" class="text-success d-flex align-items-center m-0">Modifié</p>
        <div v-if="error.postal_address" class="col-12 text-danger">{{ error.postal_address }}</div>
      </div>
    </div>
    <!-- COMPANY VAT -->
    <div class="form-group row">
      <label for="vat" class="col-12 col-md-3 col-form-label" style="font-size: small;">{{ printLang('MyAccount.Company.Domiciliation') }}&nbsp;:&nbsp;</label>
      <div class="col-md-3 col-lg-4">
        <select v-model="domiciliation" class="form-control input-lg" @change="displaySaveButton('vat')">
          <option value="fr">{{ printLang('MyAccount.Company.France') }}</option>
          <option value="eu">{{ printLang('MyAccount.Company.EuropeanUnion') }}</option>
          <option value="non-eu">{{ printLang('MyAccount.Company.NonEu') }}</option>
        </select>
      </div>
      <div v-if="domiciliation != 'fr'" class="col-md-3 col-lg-3">
        <input id="vat" v-model="domiciliationInput" class="form-control"
               :placeholder="domiciliation == 'eu' ? printLang('MyAccount.Company.VatNumber') : printLang('MyAccount.Company.Country')" type="text"
               @input="displaySaveButton('vat')">
      </div>
      <div v-if="showSave.vat">
        <button class="btn btn-success" @click="updateCompanyData('vat')">
          {{ printLang('MyAccount.Profile.Change') }}
        </button>
      </div>
      <p v-if="success.vat" class="text-success d-flex align-items-center m-0">Modifié</p>
      <div v-if="error.vat" class="col-12 text-danger">{{ error.vat }}</div>
    </div>
    <!-- COMPANY LOGO -->
    <div class="form-group" @submit.prevent="formUploadLogo()">
      <label for="logo">{{ printLang('MyAccount.Company.Logo') }}&nbsp;:&nbsp;</label>
      <p><img :src="company.logo" style="max-height: 75px; max-width: 400px;border: 1px solid #eaeff4; border-radius: 3px;"></p>
      <form id="form_upload_logo" enctype="multipart/form-data">
        <input id="logo" type="file" style="display: inline" name="file" accept="image/*" @input="showSave.logo = true">
        <button v-if="showSave.logo" type="submit" class="btn btn-success ml-2">{{ printLang('MyAccount.Company.ChangeLogo') }}</button>
        <p v-if="success.logo" class="text-success d-flex align-items-center m-0">Modifié</p>
        <div v-if="error.logo" class="col-12 text-danger">{{ error.logo }}</div>
      </form>
    </div>
  </div>
</template>

<script>
  import apiSrv from './apiSrv';
  import { printLang } from './lang';

  export default {
    props: {
      currentpage: { type: String, default: "" },
    },
    data() {
      return {
        printLang,
        company: {
          id: null,
          name: null,
          email: null,
          postal_address: null,
          logo: null,
        },
        showSave: {
          name: false,
          email: false,
          postal_address: false,
          vat: false,
          logo: false,
        },
        success: {
          name: false,
          email: false,
          postal_address: false,
          vat: false,
          logo: false,
        },
        error: {
          name: "",
          email: "",
          postal_address: "",
          vat: "",
          logo: "",
        },
        domiciliation: 'fr',
        domiciliationInput: "",
        regexEUVatNumber: /^((AT)(U\d{8})|(BE)(0\d{9})|(BG)(\d{9,10})|(CY)(\d{8}[LX])|(CZ)(\d{8,10})|(DE)(\d{9})|(DK)(\d{8})|(EE)(\d{9})|(EL|GR)(\d{9})|(ES)([\dA-Z]\d{7}[\dA-Z])|(FI)(\d{8})|(FR)([\dA-Z]{2}\d{9})|(HU)(\d{8})|(IE)(\d{7}[A-Z]{2})|(IT)(\d{11})|(LT)(\d{9}|\d{12})|(LU)(\d{8})|(LV)(\d{11})|(MT)(\d{8})|(NL)(\d{9}(B\d{2}|BO2))|(PL)(\d{10})|(PT)(\d{9})|(RO)(\d{2,10})|(SE)(\d{12})|(SI)(\d{8})|(SK)(\d{10}))$/i,
        loading: true,
      };
    },
    computed: {
      companyVat: {
        get() {
          if (this.domiciliation == 'non-eu') return `non-EU-${this.domiciliationInput}`;
          return this.domiciliation == 'eu' ? this.domiciliationInput.toUpperCase().replace(/\s/g, '') : 'france';
        },
        set(newVal) {
          if (newVal.startsWith('non-EU-')) {
            this.domiciliation = 'non-eu';
            this.domiciliationInput = newVal.replace('non-EU-', '');
          } else if (newVal.toUpperCase().replace(/\s/g, '').match(this.regexEUVatNumber)) { // if valid VAT Number
            this.domiciliation = 'eu';
            this.domiciliationInput = newVal.toUpperCase().replace(/\s/g, '');
          } else {
            this.domiciliation = 'fr';
          }
        },
      },
    },
    mounted() {
      apiSrv.loadUser(true).then((user) => {
        const { company } = user;
        if (company) {
          this.company.id = company.id;
          this.company.name = company.name;
          this.company.email = company.email;
          this.company.postal_address = company.postal_address;
          this.companyVat = company.vat || '';
          this.company.logo = company.logo;
        } else if (this.currentpage == 'company') {
          this.$emit('show-page', 'no-company');
        }
        this.loading = false;
      });
    },
    methods: {
      displaySaveButton(field) {
        this.showSave[field] = true;
        this.success[field] = false;
        this.error[field] = false;
      },
      updateCompanyData(field) {
        if (! ['name', 'email', 'postal_address', 'vat'].includes(field)) { this.error[field] = 'invalid field'; console.error('invalid field'); return; }
        if (field == 'name' && (this.company.name.length < 3 || this.company.name.length > 50)) {
          this.error[field] = printLang('MyAccount.Company.CompanyNameError');
          return;
        }
        if (this.domiciliation == 'eu' && ! this.companyVat.match(this.regexEUVatNumber)) { // if invalid EU Vat Number
          this.error[field] = printLang('MyAccount.Company.VatNumberError');
          return;
        }
        const data = {
          [field]: field == 'vat' ? this.companyVat : this.company[field],
        };
        this.showSave[field] = false;
        $.ajax({
          type: 'PUT',
          url: `${window.api.companies.url }/${this.company.id}`,
          dataType: "json",
          data,
          headers: { 'X-Auth-Token': window.api_token },
        }).then(() => {
          this.success[field] = true;
          setTimeout(() => { this.success[field] = false; }, 5000);
        }).catch((errorData) => {
          const response = errorData.responseText ? JSON.parse(errorData.responseText) : {};
          this.error[field] = window.formatApiAnswer(response.message) || `Something went wrong. ${errorData.statusText}`;
          this.showSave[field] = true;
        });
      },
      formUploadLogo() {
        const $formLogo = $('#form_upload_logo');
        const formdata = (window.FormData) ? new window.FormData($formLogo[0]) : null;
        const data = (formdata !== null) ? formdata : $formLogo.serialize();
        $.ajax({
          type: 'POST',
          url: window.api.files.url,
          contentType: false, // obligatoire pour de l'upload
          processData: false, // obligatoire pour de l'upload
          dataType: "json",
          headers: { 'X-Auth-Token': window.api_token },
          data,
        }).then((data) => {
          const imgurl = data && data.file && data.file.url;
          if (! imgurl) return;
          this.company.logo = null;
          // $('.company #logo_img').attr('src', '');
          $.ajax({
            type: 'PUT',
            url: `${window.api.companies.url}/${this.company.id}`,
            dataType: 'json',
            headers: { 'X-Auth-Token': window.api_token },
            data: { logo: imgurl },
          }).then(() => {
            this.company.logo = imgurl;
            this.showSave.logo = false;
          });
        }).catch((errorData) => {
          const response = errorData.responseText ? JSON.parse(errorData.responseText) : {};
          this.error.logo = window.formatApiAnswer(response.message) || `Something went wrong. ${errorData.statusText}`;
          this.showSave.logo = true;
        });
      },
    },
  };
</script>
